export const DATA_USER = 'data_user';
export const DATA_FAMILY = 'data_family';
export const ID_USER = 'id_user';
